import * as React from "react";

export interface ISnackbarContextState {
    readonly isSnackbarOpen: boolean;
    readonly snackbarMessage: string;
}

export interface ISnackbarContext {
    state: ISnackbarContextState;
    methods: {
        showMessage: (message: string) => void;
    }
}

export const SnackbarContext = React.createContext<ISnackbarContext>({
    state: {
        isSnackbarOpen: false,
        snackbarMessage: ""
    },
    methods: {} as any
});


// WEBPACK FOOTER //
// ./src/snackbar-context.ts